import { createGlobalStyle, css } from 'styled-components';
import localFont from 'next/font/local';
import theme from './theme';

//! Color Generator
function colorGenerator() {
	const colorsArr = Object.keys(theme.colors);

	let colorVariable = '';

	for (let i = 0; i < colorsArr.length; i++) {
		colorVariable += `--${colorsArr[i]}: ${theme.colors[colorsArr[i]]};`;
	}

	return colorVariable;
}

//! Fonts
const larken = localFont({
	src: [
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Italic.ttf',
			weight: '400',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Italic.woff',
			weight: '400',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Italic.woff2',
			weight: '400',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Light_Italic.ttf',
			weight: '300',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Light_Italic.woff',
			weight: '300',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Light_Italic.woff2',
			weight: '300',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Light.ttf',
			weight: '300',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Light.woff',
			weight: '300',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Light.woff2',
			weight: '300',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Medium_Italic.ttf',
			weight: '500',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Medium_Italic.woff',
			weight: '500',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Medium_Italic.woff2',
			weight: '500',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Medium.ttf',
			weight: '500',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Medium.woff',
			weight: '500',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Medium.woff2',
			weight: '500',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Regular.ttf',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Regular.woff',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Regular.woff2',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Thin_Italic.ttf',
			weight: '100',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Thin_Italic.woff',
			weight: '100',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Thin_Italic.woff2',
			weight: '100',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Thin.ttf',
			weight: '100',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Thin.woff',
			weight: '100',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/larken/fonnts.com-Larken_Thin.woff2',
			weight: '100',
			display: 'swap',
			style: 'normal',
		},
	],
});

const fss = localFont({
	src: [
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-BoldItalic.ttf',
			weight: '700',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-BoldItalic.woff',
			weight: '700',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-BoldItalic.woff2',
			weight: '700',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Bold.ttf',
			weight: '700',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Bold.woff',
			weight: '700',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Bold.woff2',
			weight: '700',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Regular.ttf',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Regular.woff',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Regular.woff2',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Italic.ttf',
			weight: '400',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Italic.woff',
			weight: '400',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Italic.woff2',
			weight: '400',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-LightItalic.ttf',
			weight: '300',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-LightItalic.woff',
			weight: '300',
			display: 'swap',
			style: 'italic',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-LightItalic.woff2',
			weight: '300',
			display: 'swap',
			style: 'italic',
		},

		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Light.ttf',
			weight: '300',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Light.woff',
			weight: '300',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/fs-split-sans-trial/FSSplitSansTrial-Light.woff2',
			weight: '300',
			display: 'swap',
			style: 'normal',
		},
	],
});

const Variables = createGlobalStyle`${css`
	:root {
		/* //! Container */
		--core_contPaddingLR: var(--contPaddingLR);
		--core_sectionDistance: var(--sectionDistance);

		/* //! Fonts */
		--fss: ${fss.style.fontFamily};
		--larken: ${larken.style.fontFamily};

		/* //! Transition */
		--trTime: 0.3s;

		/* //! Line Heights */
		--lineHeightS: 1.2;
		--lineHeightL: 1.3;

		/* //! Colors */
		${colorGenerator()};

		/* //! Grid Column Distance */
		--colPadding: calc(var(--gutter) / 2);
	}

	/* //! 2560 */
	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeXL}) {
		:root {
			--h1: 120px;
			--h2: 104px;
			--h3: 88px;
			--h4: 64px;
			--h5: 56px;
			--h6: 40px;
			--p1: 32px;
			--p2: 24px;
			--p3: 20px;
			--p4: 24px;
			--p5: 18px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp6x);
			--gutter: var(--sp4x);
			--sectionDistance: var(--sp25x);
			--headerFixedHeight: 129.19px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp9x);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		:root {
			--h1: 88px;
			--h2: 80px;
			--h3: 64px;
			--h4: 48px;
			--h5: 40px;
			--h6: 32px;
			--p1: 24px;
			--p2: 20px;
			--p3: 16px;
			--p4: 20px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp5x);
			--gutter: var(--sp4x);
			--sectionDistance: var(--sp20x);
			--headerFixedHeight: 116px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp8x);
		}
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		:root {
			--h1: 72px;
			--h2: 64px;
			--h3: 56px;
			--h4: 40px;
			--h5: 32px;
			--h6: 24px;
			--p1: 20px;
			--p2: 18px;
			--p3: 14px;
			--p4: 18px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp5x);
			--gutter: var(--sp3x);
			--sectionDistance: var(--sp15x);
			--headerFixedHeight: 93.39px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp7x);
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		:root {
			--h1: 64px;
			--h2: 56px;
			--h3: 48px;
			--h4: 32px;
			--h5: 24px;
			--h6: 20px;
			--p1: 18px;
			--p2: 16px;
			--p3: 14px;
			--p4: 16px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp4x);
			--gutter: var(--sp3x);
			--sectionDistance: var(--sp13x);
			--headerFixedHeight: 90.8px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp6x);
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		:root {
			--h1: 64px;
			--h2: 56px;
			--h3: 48px;
			--h4: 32px;
			--h5: 24px;
			--h6: 20px;
			--p1: 18px;
			--p2: 16px;
			--p3: 14px;
			--p4: 14px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp4x);
			--gutter: var(--sp2-5x);
			--sectionDistance: var(--sp12x);
			--headerFixedHeight: 78.8px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp5x);
		}
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeX}) {
		:root {
			--h1: 48px;
			--h2: 40px;
			--h3: 32px;
			--h4: 24px;
			--h5: 20px;
			--h6: 18px;
			--p1: 16px;
			--p2: 14px;
			--p3: 12px;
			--p4: 14px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp4x);
			--gutter: var(--sp2-5x);
			--sectionDistance: var(--sp11x);
			--headerFixedHeight: 76.19px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp5x);
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		:root {
			--h1: 48px;
			--h2: 40px;
			--h3: 32px;
			--h4: 24px;
			--h5: 18px;
			--h6: 18px;
			--p1: 16px;
			--p2: 14px;
			--p3: 12px;
			--p4: 14px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp3x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp10x);
			--headerFixedHeight: 55px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp4x);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		:root {
			--h1: 40px;
			--h2: 32px;
			--h3: 24px;
			--h4: 20px;
			--h5: 18px;
			--h6: 16px;
			--p1: 16px;
			--p2: 14px;
			--p3: 12px;
			--p4: 14px;
			--p5: 16px;

			/* //! Global Variables */
			--contPaddingLR: var(--sp2x);
			--gutter: var(--sp1x);
			--sectionDistance: var(--sp8x);
			--headerFixedHeight: 53px;

			/* //! Components Variables */
			--descBannerDistance: var(--sp4x);
		}
	}
`}`;

export default Variables;
